import { DefaultPopover, DefaultTooltip, Select } from 'twyne-new.ui'

import { useCraftProp } from '@/components/builder/utils'

const PositionImageProperty = ({ name = '', onChange, value: propValue, disabled, prefix = '' }) => {
  const { value: craftValue, setValue: setCraftValue } = useCraftProp(name)

  const position = (propValue || craftValue)?.replace(prefix, '')

  const handleChange = value => {
    onChange && onChange(prefix + value)
    setCraftValue && setCraftValue(prefix + value)
  }

  return <>
    <div className='w-full flex gap-2 items-center'>
      <Position
        position={position}
        onChange={handleChange}
      />
      <Select
        options={POSITION_OPTIONS}
        value={position}
        onChange={option => handleChange(option?.value)}
        disabled={disabled}
        clearable
        variant='accent'
      />
    </div>
  </>
}

const Position = ({ position, onChange }) => <>
  <DefaultPopover
    trigger={<PositionPreview position={position} size='small' className='mb-2' />}
    contentProps={{ side: 'bottom', align: 'center', className: 'w-full' }}
  >
    <PositionPreview position={position} onChange={onChange} size='large' className='cursor-pointer' />
  </DefaultPopover>
</>

const PositionPreview = ({ position, size = 'small', className, onChange }) => {
  const config = {
    size: {
      small: 'w-1 h-1',
      large: 'w-8 h-8',
    },
  }

  const getClassName = currentPosition => `${config.size[size]} ${currentPosition === position ? 'dark:bg-white bg-gray-1600' : 'twy-bg-neutral'}`

  const handleChangePosition = newPosition => {
    onChange && onChange(newPosition)
  }

  return <>
    <DefaultTooltip content={size === 'small' ? 'Click to change position' : ''}>
      <div className={`items-center justify-center flex flex-col gap-1 ${className}`}>
        <div className='flex gap-1'>
          <div onClick={() => handleChangePosition('top-left')} className={getClassName('top-left')}></div>
          <div onClick={() => handleChangePosition('top')} className={getClassName('top')}></div>
          <div onClick={() => handleChangePosition('top-right')} className={getClassName('top-right')}></div>
        </div>
        <div className='flex gap-1'>
          <div onClick={() => handleChangePosition('left')} className={getClassName('left')}></div>
          <div onClick={() => handleChangePosition('center')} className={getClassName('center')}></div>
          <div onClick={() => handleChangePosition('right')} className={getClassName('right')}></div>
        </div>
        <div className='flex gap-1'>
          <div onClick={() => handleChangePosition('bottom-left')} className={getClassName('bottom-left')}></div>
          <div onClick={() => handleChangePosition('bottom')} className={getClassName('bottom')}></div>
          <div onClick={() => handleChangePosition('bottom-right')} className={getClassName('bottom-right')}></div>
        </div>
      </div>
    </DefaultTooltip>
  </>
}

const POSITION_OPTIONS = [
  { label: 'Top Left', value: 'top-left' },
  { label: 'Top', value: 'top' },
  { label: 'Top Right', value: 'top-right' },
  { label: 'Left', value: 'left' },
  { label: 'Center', value: 'center' },
  { label: 'Right', value: 'right' },
  { label: 'Bottom Left', value: 'bottom-left' },
  { label: 'Bottom', value: 'bottom' },
  { label: 'Bottom Right', value: 'bottom-right' },
]

export default PositionImageProperty
